module.exports = __webpack_public_path__ + "static/img/achieve04.90832c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/achieve04.png
// module id = v5bX
// module chunks = 1